/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var KeynoteIcon = createIcon("KeynoteIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#1B9BF6';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: _color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.468 26a2 2 0 114 0v8h3a1 1 0 110 2h-10a1 1 0 110-2h3v-8Zm8.867-14a2 2 0 011.715.971l3.6 6A2 2 0 0134.935 22H14a2 2 0 01-1.715-3.029l3.6-6A2 2 0 0117.6 12h13.735Z",
    fill: "#fff"
  }));
}, {
  "i18nKey": "svg.KeynoteIcon",
  "replaceColor": true
});